export default "__VITE_ASSET__HXxYg1GY__"